import { useQuery } from '@tanstack/react-query';
import { Client } from '../../admin/users/types';

export const useClients = (
  filters: { advisorUserId?: string; familyId?: string; isTest?: boolean; companyId?: string } = {},
) => {
  const basePath = filters.companyId ? `admin/companies/${filters.companyId}/clients` : 'clients';

  const params: Record<string, unknown> = {};
  if (filters.advisorUserId) params.advisorUserId = filters.advisorUserId;
  if (filters.familyId) params.familyId = filters.familyId;
  if (filters.isTest !== undefined) params.isTest = filters.isTest;

  const { data, isLoading, isFetching, isError, refetch } = useQuery<Client[]>({
    queryKey: [basePath, params],
  });

  return {
    clients: data ?? [],
    isFetching,
    isLoading,
    isError,
    refetch,
  };
};
